/* eslint-disable import/prefer-default-export */

export class LoadingQueue {
  constructor(onComplete) {
    this.onComplete = onComplete;
    this.loadingCount = 0;
  }

  add() {
    this.loadingCount += 1;
  }

  remove() {
    this.loadingCount -= 1;
    this.check();
  }

  check() {
    if (this.loadingCount <= 0) {
      this.onComplete();
    }
  }
}

/* eslint-disable-next-line */
export function ease(obj, prop, { target = null, velocity = null, smoothCoeff = null, onComplete = () => {} } = {}) {
  /* eslint-disable no-param-reassign */
  if (target === null) {
    obj[prop] += velocity || 0;
    return;
  }

  if (obj[prop] === target) return;

  if (velocity !== null) {
    if (Math.abs(target - obj[prop]) < Math.abs(target - (obj[prop] + velocity))) {
      obj[prop] = target;
    } else {
      obj[prop] += velocity;
    }
  }

  if (smoothCoeff !== null) {
    obj[prop] += (target - obj[prop]) * smoothCoeff;

    if (Math.abs(target - obj[prop]) < 0.0025) {
      obj[prop] = target;
    }
  }

  if (obj[prop] === target && onComplete) {
    onComplete();
  }
}

/** @function oscillateXY - give oscillation between -1 & 1 */
const _oscUpdate = () => { };
let _oscX = 0;
let _oscY = 0;
let _oscTime = 0;

export function oscillateXY(onUpdate = _oscUpdate) {
  _oscTime = window.performance.now();
  _oscX = Math.cos(_oscTime * 0.00025);
  _oscY = Math.sin(_oscTime * 0.00025);
  onUpdate(_oscX, _oscY);
}
